/* Deler tekst i ord og tegn, slik at bokstavene kan animeres inn hver for seg.
   Ordet får overflow: hidden, tegnet flyttes. Markeringen holdes flat, så
   skjermlesere leser fortsatt setningen som én tekst.

   Elementene bygges med textContent, aldri innerHTML: teksten kommer fra
   admin, og et «<» eller «&» der skal vises som tegn, ikke tolkes som HTML.

   Myk bindestrek (U+00AD) legges som vanlig tekst mellom tegnene, ikke i et
   eget .tegn. Da kan nettleseren dele ordet der og vise bindestreken, i
   stedet for å vise et tomt tegn først på neste linje. */

import { $$ } from './verktoy.js';

const MYK = '­';

function lagOrd(ord) {
  const o = document.createElement('span');
  o.className = 'ord';
  for (const t of ord) {
    if (t === MYK) {
      o.append(MYK);
      continue;
    }
    const s = document.createElement('span');
    s.className = 'tegn';
    s.textContent = t;
    o.append(s);
  }
  return o;
}

export function delOppTekst(rot = document) {
  for (const el of $$('.oppdelt', rot)) {
    if (el.dataset.delt) continue;
    // Del bare på vanlige mellomrom. Et hardt mellomrom skal holde ordene sammen.
    const ord = el.textContent.trim().split(/[ \t\r\n]+/);
    el.replaceChildren();
    ord.forEach((o, i) => {
      if (i) el.append(' ');
      el.append(lagOrd(o));
    });
    el.dataset.delt = '1';
  }
}
